// NOTE: NSAI-6259 — the account menu's row shape, shared so the theme flyout's
// trigger is the same row as the ones above and below it.
//
// Its own module rather than living in `UserMenu`: the theme picker is rendered
// BY that menu, so importing the constant from there would close a cycle.
export const USER_MENU_ROW_CLASS = "gap-2.5 px-4 py-2 rounded-none font-medium";

/**
 * NOTE: NSAI-6259 — a rule at the TOP of the row that opens a new section.
 *
 * This went through two wrong versions. `divide-y` on the menu ran the rule the
 * full width of the dialog and, because it divides every direct child, drew one
 * above the first row under an identity block that can be empty — a rule with
 * nothing above it. Moving it onto every row fixed the geometry and made the
 * real mistake obvious: eleven rows with a line between each is a striped list,
 * not a menu.
 *
 * The request was separators between SECTIONS. There are four here — chrome
 * (theme, notifications), account (settings through calendars), help (FAQ,
 * docs), and the sign-out — so there are three rules, not ten.
 *
 * `after`/`before` on the row rather than a bordered wrapper: the rows are
 * conditional on permissions and feature flags, so grouping them in wrapper
 * elements would mean a wrapper that can render empty and collapse to a stray
 * rule. Marking the first row of each section keeps the rule attached to a row
 * that is actually on screen.
 *
 * `foreground/15` rather than `--border`: this sits on the popover surface, not
 * on the page, and the border token is too close to it to read there. Deriving
 * from the foreground gives a light line in dark theme and a dark one in light.
 */
export const USER_MENU_SECTION_START_CLASS = `${USER_MENU_ROW_CLASS} relative mt-1 before:absolute before:inset-x-4 before:top-0 before:h-px before:bg-foreground/15 before:content-['']`;
